var svse = {
	"coupon-callout": {
	"coupon-code": "Rabattkod",
	"coupon-message-with-price": "Skriv {{ price }}",
	"coupon-expiry-message": "Giltigt t.o.m. {{ Date }}.",
	"code-at-checkout": "Ange koden i kassan. Kan inte kombineras med andra rabattkoder, kampanjer eller rabatter.",
	"cancel-icon": "Avbryt",
	"info-icon": "Mer information",
	"check-icon": "Tillämpad",
	"promo-code": "Rabattkod",
	"coupon-callout-popover": "Kupong i pop up-ruta"
}
};

export { svse as default };
//# sourceMappingURL=src-localization-texts-sv-se.json.js.map
